var exports = {
  "k": "x61f99309--42324e--container",
};

module.exports = exports;
